<template>
  <div class="cr-account">
    <div class="cr-container">
      <div class="cr-account__section">
        <div class="cr-account__main">
          <div class="cr-account__header">
            <div class="cr-account__title">
              {{user.bar_name }}
            </div>
            <div class="cr-account__person">
              {{user.last_name }} {{user.name }} {{user.second_name }}
            </div>
          </div>
          <div class="cr-account__contact">
            <div class="cr-account__contact-position">
              Ваш менеджер
            </div>
            <div class="cr-account__contact-name">
              {{user.manager_name }}
            </div>
            <div class="cr-account__contact-links">
              <a class="cr-account__contact-link" :href="'tel:'+user.manager_phone">
                {{user.manager_phone }}
              </a>
            </div>
          </div>
        </div>
        <nav class="cr-account__menu cr-menu">
          <ul class="cr-menu__list">
            <li class="cr-menu__item">
              <router-link class="cr-menu__link" to="/personal/profile/">
                Личные данные
              </router-link>
            </li>
            <li class="cr-menu__item">
              <router-link class="cr-menu__link" to="/personal/address/">
                Адреса отгрузки
              </router-link>
            </li>
            <li class="cr-menu__item">
              <router-link class="cr-menu__link" to="/personal/report/">
                Взаиморасчеты
              </router-link>
            </li>
            <li class="cr-menu__item">
              <router-link class="cr-menu__link" to="/personal/orders/">
                История заказов
              </router-link>
            </li>
            <li class="cr-menu__item" v-if="false">
              <router-link class="cr-menu__link" to="/personal/accounts/">
                Мои аккаунты
              </router-link>
            </li>
          </ul>
        </nav>
      </div>
      <div v-if="mainLoaded" class="cr-account__section">
        <Menu></Menu>
      </div>
      <div class="cr-account__section">
        <div class="cr-account__action">
          <button @click="logoutFromAccount" class="cr-button cr-button--light" type="button">
                            <span class="cr-button__text">
                                Выйти из аккаунта
                            </span>
          </button>
          <router-link to="/personal/remove/" class="cr-link cr-link--color" type="button">
            Удалить аккаунт
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapActions, mapGetters} from "vuex";
import Menu from "@/views/components/Menu.vue";
import axios from "axios";

export default {
  data: () => ({

  }),
  computed: {
    ...mapGetters([
      'user',
    ]),
  },
  created() {

  },
  components: {Menu},
  methods: {
    ...mapActions([
      'logout'
    ]),
    ...mapActions('counter', [
      'fetchCounterData'
    ]),
    async logoutFromAccount() {
      await this.logout();
      this.fetchCounterData(true);
      this.$router.push('/auth/');
    }
  },
}
</script>
